import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Backdrop,
  Box,
  Divider,
} from '@mui/material';
import { StyledDialog } from 'theme/index';

interface ConfirmDeleteDialogProps {
  open: boolean;
  title?: string;
  message: string;
  action?: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function ConfirmDeleteDialog({
  open,
  title = 'Confirm Delete',
  message,
  action = 'Delete',
  onCancel,
  onConfirm,
}: ConfirmDeleteDialogProps) {
  return (
    <StyledDialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography textAlign='center' color='error' fontWeight={500}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color='error' variant='outlined' onClick={onCancel}>
          Cancel
        </Button>
        <Button color='success' variant='outlined' onClick={onConfirm}>
          {action}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
}
